import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

// Pages
import Login from './pages/Login/Login';
import ActivateAccount from './pages/Auth/ActivateAccount';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import Dashboard from './pages/Dashboard/Dashboard';

import UserList from './pages/Users/UserList';
import UserForm from './pages/Users/UserForm';

import ClientList from './pages/Clients/ClientList';
import ClientForm from './pages/Clients/ClientForm';

import ProjectList from './pages/Projects/ProjectList';
import ProjectForm from './pages/Projects/ProjectForm';

import TimeEntryList from './pages/TimeEntries/TimeEntryList';
import TimeEntryForm from './pages/TimeEntries/TimeEntryForm';

import ApprovalList from './pages/Approvals/ApprovalList';
import ImportManager from './pages/Imports/ImportManager';
import Reports from './pages/Reports/Reports';
import Settings from './pages/Settings/Settings';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />
          <Route path="/ativar-conta/:key" element={<ActivateAccount />} />
          <Route path="/esqueci-senha" element={<ForgotPassword />} />
          <Route path="/redefinir-senha/:uid/:token" element={<ResetPassword />} />

          {/* Redirect root to dashboard */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Protected routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout>
                  <Dashboard />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Users - staff only */}
          <Route
            path="/users"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <UserList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/users/new"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <UserForm />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/users/:id/edit"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <UserForm />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Clients - staff only */}
          <Route
            path="/clients"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <ClientList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/clients/new"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <ClientForm />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/clients/:id/edit"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <ClientForm />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Projects - staff only */}
          <Route
            path="/projects"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <ProjectList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/projects/new"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <ProjectForm />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/projects/:id/edit"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <ProjectForm />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Time Entries - all authenticated */}
          <Route
            path="/time-entries"
            element={
              <PrivateRoute>
                <Layout>
                  <TimeEntryList />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/time-entries/new"
            element={
              <PrivateRoute>
                <Layout>
                  <TimeEntryForm />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/time-entries/:id/edit"
            element={
              <PrivateRoute>
                <Layout>
                  <TimeEntryForm />
                </Layout>
              </PrivateRoute>
            }
          />
          <Route
            path="/time-entries/:id/copy"
            element={
              <PrivateRoute>
                <Layout>
                  <TimeEntryForm mode="copy" />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Approvals - staff only */}
          <Route
            path="/approvals"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <ApprovalList />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Imports - staff only */}
          <Route
            path="/imports"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <ImportManager />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Reports - all authenticated (consultor ve so os proprios dados) */}
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Layout>
                  <Reports />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Settings - staff only */}
          <Route
            path="/settings"
            element={
              <PrivateRoute roleRequired="staff">
                <Layout>
                  <Settings />
                </Layout>
              </PrivateRoute>
            }
          />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
